<template>
  <div class="container-fluid">
    <table class="xz-table">
      <thead>
      <tr class="bold">
        <th>Betalingsmiddel</th>
        <th>Antall</th>
        <th></th>
        <th>Beløp</th>
      </tr>
      </thead>
      <tbody>

      <tr>
        <td colSpan="4"><b>Kort</b></td>
      </tr>
      <tr>
        <td>BankAxept</td>
        <td>{{ transactionsReport.bankAxeptCount }}</td>
        <td></td>
        <td>{{ displayTwoDecimals(transactionsReport.bankAxeptPaymentsTotalAmount) }}</td>
      </tr>
      <tr>
        <td>Visa/Mastercard/Andre</td>
        <td>{{ transactionsReport.nonBankAxeptCount }}</td>
        <td></td>
        <td>{{ displayTwoDecimals(transactionsReport.nonBankAxeptPaymentsTotalAmount) }}</td>
      </tr>
      <tr class="bold">
        <td>Total kort</td>
        <td>{{ cardTotalCount }}</td>
        <td></td>
        <td>{{ displayTwoDecimals(cardPaymentsTotalAmount) }}</td>
      </tr>
      </tbody>
    </table>
    <hr class="horizontal-dashed"/>
  </div>
</template>

<script>
  import MathUtil from "@/util/MathUtil";

  export default {
    props: {
      transactionsReport: Object
    },
    computed: {
      cardTotalCount() {
        let bankAxeptCount = this.transactionsReport.bankAxeptCount;
        let nonBankAxeptCount = this.transactionsReport.nonBankAxeptCount;
        return (bankAxeptCount + nonBankAxeptCount);
      },

      cardPaymentsTotalAmount() {
        return this.transactionsReport.bankAxeptPaymentsTotalAmount + this.transactionsReport.nonBankAxeptPaymentsTotalAmount;
      }
    },
    methods: {
      displayTwoDecimals(num){
        if(num > 0 || num < 0){
          return MathUtil.displayTwoDecimals(num);
        }else {
          return num;
        }
      }
    }
  }
</script>
